import PropTypes from 'prop-types';
// @mui
import { useContext } from 'react';

import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
import UserContext from 'src/contexts/UserContext';
import { auth } from '../../../components/firebase/firebase';
import { useEffect } from 'react';
import { useState } from 'react';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { userContext } = useContext(UserContext);
  const { user, setUser } = useState(null);

  useEffect(() => {
    if (auth.currentUser !== null) {
      setUser(auth.currentUser);
    }
  }, []);

  return (
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        { user !== undefined && <Avatar imgProps={{ referrerPolicy: "no-referrer" }}
          src={user.photoURL} alt={user.displayName} /> }
        {user === undefined && <Avatar src="" alt="User Not Logged In" /> }
        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Typography variant="subtitle2" noWrap>
           { user && user.displayName}
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            Administrator
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
